export enum UserStatus {
    Published = 'published',
    Unpublished = 'unpublished'
}

